/**
 * D-121 — PM web WorkerList queue-health column cell.
 *
 * Pure presentational component: takes pre-aggregated counts (bytes + photos)
 * and renders a colored span per the D-119 thresholds shared with the Android
 * QueueBanner derivation:
 *   ratio = max(queueBytes / 200_000_000, queuePhotoCount / 100)
 *   < 0.75 → green (slate-600 — NOT alarmed)
 *   0.75 <= ratio < 0.90 → yellow
 *   >= 0.90 → red
 *
 * Latin digits regardless of locale per spec (asset/queue numerics are NOT
 * mirrored to Eastern-Arabic).
 */
interface QueueHealthCellProps {
  queueBytes: number;
  queuePhotos: number;
}

export function QueueHealthCell({ queueBytes, queuePhotos }: QueueHealthCellProps) {
  const byteRatio = queueBytes / 200_000_000;
  const countRatio = queuePhotos / 100;
  const ratio = Math.max(byteRatio, countRatio);
  const colorClass =
    ratio >= 0.9 ? "text-error" : ratio >= 0.75 ? "text-warning" : "text-text-secondary";
  const mb = (queueBytes / (1024 * 1024)).toFixed(1);
  return (
    <span className={colorClass} data-testid="queue-health-cell">
      {queuePhotos} ({mb} MB)
    </span>
  );
}
